import { createCtx } from '@mi-front/core';
import { UseReportResult } from './components/useReport';
import { ReportType } from './types';

export interface ReportCtxType<
  R extends ReportType<Values, Result>,
  Values extends object = any,
  Result = any,
> {
  defaultValues: Values;
  formats?: string[];
  result?: Result | null;
  allowDownload?: boolean;
  previewReport: (values: R['Values']) => any;
}

export const [_useReportCtx, ReportCtxProvider] = createCtx<UseReportResult<any>>();

export function useReportCtx<R extends ReportType>() {
  return _useReportCtx() as UseReportResult<R>;
}
